import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';

import {
  createOrder,
  createOrderFail,
  createOrderSuccess,
  getOrder,
  getOrderFail,
  getOrderSuccess,
  getOrderList,
  getOrderListFail,
  getOrderListSuccess,
} from '@b2b/features/order/core/store/order.actions';
import { OrderConnector } from '@b2b/features/order/core/order.connector';

@Injectable()
export class OrderEffects {
  constructor(
    private actions: Actions,
    private orderConnector: OrderConnector,
  ) {}

  getOrder$ = createEffect(() => {
    return this.actions.pipe(
      ofType(getOrder),
      mergeMap(({ code }) => {
        return this.orderConnector.get(code).pipe(
          map(order => {
            if (order.hasError) {
              return getOrderFail({ message: order.message || '' });
            }

            return getOrderSuccess({ data: order.data! });
          }),
        );
      }),
    );
  });

  getOrderList$ = createEffect(() => {
    return this.actions.pipe(
      ofType(getOrderList),
      mergeMap(({ b2bUnitUid, customerUid, page }) => {
        return this.orderConnector.list(b2bUnitUid, customerUid, page ?? 1).pipe(
          map(response => {
            if (response.hasError) {
              return getOrderListFail({ message: response.message || '' });
            }

            const { items, currentPage, totalPages } = response.data!;

            return getOrderListSuccess({ data: items, currentPage, totalPages });
          }),
        );
      }),
    );
  });

  createOrder$ = createEffect(() => {
    return this.actions.pipe(
      ofType(createOrder),
      mergeMap(() => {
        return this.orderConnector.create().pipe(
          map(order => {
            if (order.hasError) {
              return createOrderFail({ message: order.message || '' });
            }

            return createOrderSuccess({ data: order.data! });
          }),
        );
      }),
    );
  });
}
